<template>
  <div class="d-activity-repost activity white">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span v-if="activity.source.repost">
          reposted
          <DUserLinkPopup
            :user-id="activity.source.repost.user.id"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="activity.source.repost.url"
              >{{ activity.source.repost.user.firstname }} {{ activity.source.repost.user.lastname }}'s update</a>
            </template>
          </DUserLinkPopup>

        </span>

        <span v-else>
          reposted
          <DUserLinkPopup
            :user-id="activity.source.repost_user.id"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="activity.source.repost_user.url"
              >{{ activity.source.repost_user.firstname }} {{ activity.source.repost_user.lastname }}</a>'s update
            </template>
          </DUserLinkPopup>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <div class="comment">
      <DTextWithLinks
        :content="activity.comment || activity.source.content"
        :display-multiline="true"
        :display-typed-links="true"
        :mentions="activity.source.mentions"
      />
    </div>

    <div
      class="original-activity"
      :class="{ 'linked': isLinkEnabled }"
      @click="goToOriginalActivity"
    >
      <DActivityActivity
        v-if="!!activity.source.repost"
        :activity="activity.source.repost"
        :is-repost="true"
        :is-user-signed-in="isUserSignedIn"
      />

      <div
        v-else
        class="activity-removed"
      >
        The original post is no longer available.
      </div>
    </div>
  </div>
</template>

<script>
import DActivityActions from './shared/d-activity-actions/d-activity-actions.vue';
import DActivityActivity from './d-activity-activity.vue';
import DActivityAuthor from './shared/d-activity-author/d-activity-author.vue';
import DActivityAvatar from './shared/d-activity-avatar/d-activity-avatar.vue';
import DActivityTimestamp from './shared/d-activity-timestamp/d-activity-timestamp.vue';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';
import DTextWithLinks from '@d-components/d-text-with-links/d-text-with-links.vue';
import { POST_LINK_ENABLED_TYPES } from '@d-shared/config';
import Window from '@d-shared/utils/window';

export default {
  components: {
    DActivityActions,
    DActivityActivity,
    DActivityAuthor,
    DActivityAvatar,
    DActivityTimestamp,
    DTextWithLinks,
    DUserLinkPopup,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isLinkEnabled: false,
  }),
  mounted() {
    this.setIsLinkEnabled();
  },
  methods: {
    activityRemoved() {
      this.$emit('activity-removed');
    },

    goToOriginalActivity(ev) {
      if (!this.isLinkEnabled) {
        return;
      }

      ev.stopPropagation();
      Window.goTo(this.activity.source.repost.url);
    },

    setIsLinkEnabled() {
      if (!this.activity.source.repost) {
        return;
      }

      if (POST_LINK_ENABLED_TYPES.indexOf(this.activity.source.repost.type) === -1) {
        return;
      }

      this.$set(this, 'isLinkEnabled', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";
@import "../activity";

.d-activity-repost {
  .original-activity {
    @include originalActivityStyling();

    &.linked {
      cursor: pointer;
    }

    .activity-removed {
      color: getColor($grey, dark);
    }
  }
}
</style>
